import { useEffect, useState } from 'react';
import API from 'services/API';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

const catalogEndpoints = {
  JobOrderStatuses: `${Endpoints.JobOrderStatuses}?selectable=true`,
  JobOrderTypes: Endpoints.JobOrderTypes,
  WorkTypes: Endpoints.WorkTypes,
  FeeAgreements: `${Endpoints.FeeAgreementsByCompany}?companyId=:companyId`
};

const formatResponse = ({ data, status }) => ({ data, status });

const useFetchCatalogs = ({ companyId }) => {
  const [uiState, setUiState] = useState(UIStatus.Loading);
  const [catalogs, setCatalogs] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setUiState(UIStatus.Loading);

      try {
        const [jobOrderStatuses, jobOrderTypes, workTypes, feeAgreements] = await Promise.all([
          API.get(catalogEndpoints.JobOrderStatuses).then(formatResponse),
          API.get(catalogEndpoints.JobOrderTypes).then(formatResponse),
          API.get(catalogEndpoints.WorkTypes).then(formatResponse),
          API.get(catalogEndpoints.FeeAgreements.replace(':companyId', companyId)).then(
            formatResponse
          )
        ]);

        setCatalogs({
          jobOrderStatuses,
          jobOrderTypes,
          workTypes,
          feeAgreements
        });

        setUiState(UIStatus.Success);
      } catch (error) {
        setUiState(UIStatus.Error);
      }
    };

    if (!companyId) {
      setUiState(UIStatus.Default);
      return;
    }

    fetchData();
  }, [companyId]);

  return {
    catalogs,
    uiState
  };
};

export default useFetchCatalogs;
